import { DEFAULT_CURRENCY, DEFAULT_QUANTITY, normalizeNumber, normalizeSegment } from '../../core/normalizers';
import type { GTMUserDataSource } from '../../core/user';
import { GTMItemType, GTMOrderType } from '../../types';
import type { TrackingCommerce } from '../../types';

type EquipmentListProduct = {
    variantCode?: string;
    code?: string;
    name?: string;
    brand?: string;
    category?: string;
    color?: string;
    internalMemory?: string;
    fullPrice?: number;
    oldFullPrice?: number;
};

type EquipmentListEventData = {
    products: EquipmentListProduct[];
    itemListName: string;
    itemListId: string;
    itemCategory?: string;
    segment?: string;
    index?: number;
    userData?: GTMUserDataSource | null;
};

export type EquipmentListEventInput = {
    source: 'equipmentList';
    data: EquipmentListEventData;
};

export const mapEquipmentListToTrackingCommerce = ({
    products,
    itemListName,
    itemListId,
    itemCategory,
    segment,
    index: selectedIndex,
}: EquipmentListEventData): TrackingCommerce => {
    const items = products.map((product, index) => {
        const price = normalizeNumber(product.fullPrice);
        const originalPrice = normalizeNumber(product.oldFullPrice) || price;

        return {
            type: GTMItemType.Product,
            id: product.variantCode || product.code || '',
            name: product.name || '',
            brand: product.brand || '',
            variant: [product.color, product.internalMemory].filter(Boolean).join(' '),
            category: product.category || itemCategory || itemListName,
            listId: itemListId,
            listName: itemListName,
            index: products.length === 1 && selectedIndex !== undefined ? selectedIndex : index,
            originalPrice,
            price,
            nboDiscount: 0,
            discount: 0,
            quantity: DEFAULT_QUANTITY,
        };
    });
    const listNames = [...new Set(items.map((item) => item.listName).filter(Boolean))];
    const value = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

    return {
        orderType: GTMOrderType.Equipment,
        segment: segment ? normalizeSegment(segment) : '',
        currency: DEFAULT_CURRENCY,
        value,
        itemListName: listNames.length > 1 ? 'Mixed' : listNames[0] || itemListName,
        giftIncluded: false,
        coupon: '',
        paymentType: '',
        paymentMethod: '',
        signMethod: '',
        bank: '',
        transactionId: '',
        items,
    };
};
